import axios from "axios";
import {SALESBOX_API_URL,LOGIN_URL} from "@/common/config";
import router from "../../router";


function init() {
    const customAxios=axios.create({
        baseURL: SALESBOX_API_URL,
        //timeout: 10000
    })

    const requestHandler = request => {
        // Token will be dynamic so we can use any app-specific way to always
        // fetch the new token before making the call
        request.headers.Authorization = 'Bearer ' + localStorage.getItem('token');

        return request;
    };

    const responseHandler = response => {
        switch (response.status) {
            case 401:
                router.replace({
                    path: LOGIN_URL,
                    query: {redirect: router.currentRoute.fullPath}
                });
                break;

            case 403:
                router.replace({
                    path: LOGIN_URL,
                    query: { redirect: router.currentRoute.fullPath }
                });
                break;
        }

        return response;
    };

    const errorHandler = error => {
        return Promise.reject(error);
    };

    customAxios.interceptors.request.use(
        (request) => requestHandler(request),
        (error) => errorHandler(error)
    );

    customAxios.interceptors.response.use(
        (response) => responseHandler(response),
        (error) => errorHandler(error)
    );

    return customAxios
}

const Api = {
    get(resource, params = null) {
        return init().get(resource, params);
    },
    post(resource, postDatas, params = null) {
        return init().post(resource, postDatas, params);
    },
};

export default Api;
